module.exports = __webpack_public_path__ + "img/img-1-mobile.4e12e64a.png";